(function(document) {

    // Navigazione verso un dominio esterno senza l'interstitial Shopify "Are you sure you want to leave".
    // Lo script shopify.exit_interstitial intercetta i cambi di location e i click sui link verso host non
    // in allowedHosts, ma non i submit di form POST: si naviga quindi con un form nascosto (fallback: replace).
    function goExternal(url) {
        try {
            var f = document.createElement("form")
            f.method = "POST"
            f.action = url
            f.style.display = "none"
            document.body.appendChild(f)
            f.submit()
        } catch (e) {
            window.location.replace(url)
        }
    }

    // i18n: stringhe display (fornite dal template via window.warrantyClaimI18n).
    // Fallback in inglese se il blocco non e' presente. NON contiene chiavi logiche.
    var WCI18N = Object.assign({
        title_warranty_claim: "Warranty Claim",
        title_part_request: "Part Request",
        submit_error: "Something went wrong while sending your application. Please try again in a moment.",
        submit_error_files: "One of the photos could not be accepted (images only, max 2MB each). Please check the files and try again.",
        intro_line1_warranty_claim: "This form will guide you through the warranty claim process.",
        intro_line1_part_request: "This form will guide you through the part request process.",
        title_not_covered: "Not Covered By Warranty",
        warranty_title_default: "Union Binding Company Warranty",
        warranty_title_boots: "Union Boot Division Warranty",
        purchase_year_default: "Binding purchase year:",
        purchase_year_boots: "Boots purchase year:",
        step3_desc_default_l1: "*The binding image and parts below may not reflect your exact model.",
        step3_desc_default_l2: "Please select the part/ or parts that are most like your binding model.",
        step3_desc_boots_l1: "*The boot image and parts below may not reflect your exact model.",
        step3_desc_boots_l2: "Please select the part/ or parts that are most like your boot model.",
        form_info_default: "Binding Information",
        form_info_boots: "Boots Information",
        photo_entire_default: "Photo of the entire Binding* (max 2MB):",
        photo_entire_boots: "Photo of the entire Boot* (max 2MB):",
        recap_info_default: "Binding Information",
        recap_info_boots: "Boot Information",
        recap_entire_default: "Entire Binding",
        recap_entire_boots: "Entire Boot",
        dont_know: "don't know"
    }, window.warrantyClaimI18n || {});

    // Titolo pagina derivato dal requestType (chiave logica interna, mai tradotta).
    function wcRequestTitle() {
        return sessionStorage.getItem("requestType") === "Part Request"
            ? WCI18N.title_part_request
            : WCI18N.title_warranty_claim;
    }
    // Frase introduttiva derivata dal requestType (part request / warranty claim).
    function wcIntroLine1() {
        return sessionStorage.getItem("requestType") === "Part Request"
            ? WCI18N.intro_line1_part_request
            : WCI18N.intro_line1_warranty_claim;
    }
    // Aggiorna insieme titolo pagina e frase introduttiva.
    function syncRequestTexts() {
        pageTitle.innerHTML = wcRequestTitle()
        var introEl = document.querySelector(".wc-intro-line1")
        if (introEl && wcIntroLine1()) introEl.textContent = wcIntroLine1()
    }

    sessionStorage.setItem("countryClaim", "") // Step1 country
    sessionStorage.setItem("isCovered", "") // Step2 covered

    sessionStorage.setItem("involvedParts", "") // List of involved parts
    sessionStorage.setItem("requestType", "Warranty Claim") // "Warranty Claim" or "Part Request", default "Warranty Claim"

    sessionStorage.setItem("purchasedYear", "") // Binding purchase year

    var selectors = {
        pageTitle: '.page-new-warranty-claim h1',
        claimStep1: '.claim-step[attr_step="1"]',
        claimStep2: '.claim-step[attr_step="2"]',
        claimStep3:  '.claim-step[attr_step="3"]',
        claimStep4:  '.claim-step[attr_step="4"]',
        claimStepFormProcess1:  '.claim-step[attr_step="covered-1"]',
        claimStepFormProcess2:  '.claim-step[attr_step="covered-2"]',
        claimStepFormRecap:  '.claim-step[attr_step="recap"]',
        claimStepPartRequest: '.claim-step[attr_step="part-request"]', 
        goto_step3: '.cta--step-3',
        claimStep1_country: '.claim-step__country',
        claimResult_distribution: '.section-result-distributor',
        claimResult_distributionContent: '.section-result-distributor__content',
        select_covered: '.claim-step__covered',
        covered: '.covered-step__single',
        componentPartImages: '.part-image',
        componentListPins: '.component-list .spec_pin',
        componentPartsImagePins: ".involved-parts__binding-parts__image .spec_pin",
        componentsPartsBtns: ".involved-parts__binding-parts__select__btn",
        componentsPartsImages: ".involved-parts__binding-parts__image",
        componentsPartsLists: ".involved-parts__components-list",
        yearPurchaseSelect: ".claim-step__purchased",
        yearPurchaseOption: ".purchased-step__single",
        stepSelectFormCountries: ".step-form-country",
        stepSelectFormModels: ".step-form-info__model",
        stepSelectFormDirections: ".step-form-info__direction",
        stepSelectFormSizes: ".step-form-info__size",
        stepFormModels: ".step-form-info__model__single",
        stepFormDirections: ".step-form-info__direction__single",
        stepFormSizes: ".step-form-info__size__single",
        stepFormMessage: ".step-form-message textarea",
        stepFormContacts: ".step-form-contact",
        stepFormShips: ".step-form-ship",
        recapParts: ".claim-recap-parts",
        recapBindingModel: ".claim-recap-binding",
        recapShip: ".claim-recap-ship",
        recapInfos: ".claim-recap-infos",
        claimWarranty: ".claim-warranty",
        claimPre: '.claim-pre',
        claimAfter: '.claim-after',
        claimSteps : '.claim-step',
        errorAfter: '.error-after',
        claimSubmit: '.claim-submit',
        claimSubmitBtn: '.claim-submit .cta',
        claimSubmitPrivacy: '.claim-recap-privacy input[name="privacy"]',
        infoImage__b: '#binding',
        infoImage__p: '#part',
        infoImage__purchase: '#purchase',
        country_pre_compiled: '.country-pre-compiled input'
    };

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var stepUrl = urlParams.get('step')

    var actualYear = new Date().getFullYear()
    var coveredYear = actualYear - 2

    var localDomain = window.location.hostname

    var involvedPartsList = ""

    var pageTitle = document.querySelector(selectors.pageTitle);
    var claimStep1 = document.querySelector(selectors.claimStep1);
    var claimStep2 = document.querySelector(selectors.claimStep2);
    var claimStep3 = document.querySelector(selectors.claimStep3);
    var claimStep4 = document.querySelector(selectors.claimStep4);
    var claimStepFormProcess1 = document.querySelector(selectors.claimStepFormProcess1);
    var claimStepFormProcess2 = document.querySelector(selectors.claimStepFormProcess2);
    var claimStepFormRecap = document.querySelector(selectors.claimStepFormRecap);
    var claimStepPartRequest = document.querySelector(selectors.claimStepPartRequest);
    var checkPartInsert = false
    var claimStep1_country = document.querySelector(selectors.claimStep1_country);
    var countries = ""
    var goto_step3 = document.querySelector(selectors.goto_step3);
    var claimResult_distribution = document.querySelector(selectors.claimResult_distribution);
    var claimResult_distributionContent = document.querySelector(selectors.claimResult_distributionContent);
    var select_covered = document.querySelector(selectors.select_covered);
    var covered = document.querySelectorAll(selectors.covered);
    var componentPartImages = document.querySelectorAll(selectors.componentPartImages);
    var componentListPins = document.querySelectorAll(selectors.componentListPins);
    var componentPartsImagePins = document.querySelectorAll(selectors.componentPartsImagePins);
    var componentsPartsBtns = document.querySelectorAll(selectors.componentsPartsBtns);
    var componentsPartsImages = document.querySelectorAll(selectors.componentsPartsImages);
    var componentsPartsLists = document.querySelectorAll(selectors.componentsPartsLists);
    var yearPurchaseSelect = document.querySelector(selectors.yearPurchaseSelect);
    var yearPurchaseOption = document.querySelectorAll(selectors.yearPurchaseOption);
    var stepSelectFormCountries = document.querySelector(selectors.stepSelectFormCountries);
    var stepSelectFormModels = document.querySelector(selectors.stepSelectFormModels);
    var stepSelectFormDirections = document.querySelector(selectors.stepSelectFormDirections);
    var stepSelectFormSizes = document.querySelector(selectors.stepSelectFormSizes);
    var stepFormModels = document.querySelectorAll(selectors.stepFormModels);
    var stepFormDirections = document.querySelectorAll(selectors.stepFormDirections);
    var stepFormSizes = document.querySelectorAll(selectors.stepFormSizes);
    var stepFormMessage = document.querySelector(selectors.stepFormMessage);
    // BOOTS: boot size (Mondo) + color dropdown + wrapper per il toggle
    var stepSelectFormBootSizes = document.querySelector(".step-form-info__bootsize");
    var stepFormBootSizes = document.querySelectorAll(".step-form-info__bootsize__single");
    var stepSelectFormColors = document.querySelector(".step-form-info__color");
    var stepFormColors = document.querySelectorAll(".step-form-info__color__single");
    var fieldDirection = document.querySelector(".select-info--direction");
    var fieldSize = document.querySelector(".select-info--size");
    var fieldBootSize = document.querySelector(".select-info--bootsize");
    var fieldColor = document.querySelector(".select-info--color");
    var selectedBindingType = "";
    var recapParts = document.querySelector(selectors.recapParts);
    var recapBindingModel = document.querySelector(selectors.recapBindingModel);
    var recapModel = recapBindingModel.querySelector(".claim-recap-binding__model")
    var recapYear = recapBindingModel.querySelector(".claim-recap-binding__year")
    var recapDirection = recapBindingModel.querySelector(".claim-recap-binding__direction")
    var recapSize = recapBindingModel.querySelector(".claim-recap-binding__size")
    var recapColor = recapBindingModel.querySelector(".claim-recap-binding__color")
    var recapMessage = recapBindingModel.querySelector(".claim-recap-binding__how")
    var recapInfos = document.querySelector(selectors.recapInfos)
    var recapInfosFirstName = recapInfos.querySelector(".claim-recap-info__firstname")
    var recapInfosLastName = recapInfos.querySelector(".claim-recap-info__lastname")
    var recapInfosEmail = recapInfos.querySelector(".claim-recap-info__email")
    var recapInfosPhone = recapInfos.querySelector(".claim-recap-info__phone")
    var recapShip = document.querySelector(selectors.recapShip);
    var recapShipAddr1 = recapShip.querySelector(".claim-recap-ship__addr1")
    var recapShipAddr2 = recapShip.querySelector(".claim-recap-ship__addr2")
    var recapShipCity = recapShip.querySelector(".claim-recap-ship__city")
    var recapShipState = recapShip.querySelector(".claim-recap-ship__state")
    var recapShipZip = recapShip.querySelector(".claim-recap-ship__zip")
    var recapShipCountry = recapShip.querySelector(".claim-recap-ship__country")
    var stepFormContacts = document.querySelector(selectors.stepFormContacts)
    var stepFormContacts_imageB = document.querySelector(".file-upload input[name='binding']")
    var stepFormContacts_imageP = document.querySelector(".file-upload input[name='part']")
    var stepFormContacts_firstname = stepFormContacts.querySelector(".input-contact input[name='firstname']")
    var stepFormContacts_lastname = stepFormContacts.querySelector(".input-contact input[name='lastname']")
    var stepFormContacts_email = stepFormContacts.querySelector(".input-contact input[name='email']")
    var stepFormContacts_phone = stepFormContacts.querySelector(".input-contact input[name='phone']")
    var stepFormShips = document.querySelector(selectors.stepFormShips)
    var stepFormShips_address1 = stepFormShips.querySelector(".input-contact input[name='address1']")
    var stepFormShips_address2 = stepFormShips.querySelector(".input-contact input[name='address2']")
    var stepFormShips_city = stepFormShips.querySelector(".input-contact input[name='city']")
    var stepFormShips_state = stepFormShips.querySelector(".input-contact input[name='stateclaim']")
    var stepFormShips_stateUS = stepFormShips.querySelector(".input-contact select[name='stateclaim-us']")
    var stepFormShips_stateCA = stepFormShips.querySelector(".input-contact select[name='stateclaim-ca']")
    var stepFormShips_zip = stepFormShips.querySelector(".input-contact input[name='zip']")
    var stepFormShips_country = stepFormShips.querySelector(".input-contact input[name='country']")
    var claimWarranty = document.querySelector(selectors.claimWarranty);
    var claimPre = document.querySelector(selectors.claimPre);
    var claimAfter = document.querySelector(selectors.claimAfter);
    var claimSteps = document.querySelectorAll(selectors.claimSteps);
    var errorAfter = document.querySelector(selectors.errorAfter);
    var claimSubmit = document.querySelector(selectors.claimSubmit);
    var claimSubmitBtn = document.querySelector(selectors.claimSubmitBtn);
    var claimSubmitPrivacy = document.querySelector(selectors.claimSubmitPrivacy);
    var infoImage__b = document.querySelector(selectors.infoImage__b);
    var infoImage__p = document.querySelector(selectors.infoImage__p);
    var infoImage__purchase = document.querySelector(selectors.infoImage__purchase);
    var country_pre_compiled = document.querySelector(selectors.country_pre_compiled);
    var async_country_step = function () {

        country_selected = this.textContent
        country_pre_compiled.value = country_selected
        recapShipCountry.innerHTML = country_selected
        region_selected = this.getAttribute("attr-region")
        state_selected = this.getAttribute("attr-filter")

        claimStep1_country.insertAdjacentElement('afterbegin', this);
        // claimStep1_country.classList.remove("open")
        // claimStep1_country.querySelector(".fa-chevron-down").classList.remove("open")
        if (claimStep1_country.querySelector(".select-style__single--select")) {
            claimStep1_country.querySelector(".select-style__single--select").remove()
        }

        if  (
                (region_selected == "NA") || 
                (region_selected == "EU") || 
                (region_selected == "JP") || 
                (region_selected == "AUS") || 
                (region_selected == "NZL")
            ) {

                console.log(localDomain)
                console.log(region_selected)

                switch (true) {
                    case localDomain == "unionbindingcompany.com" && region_selected == "NA":
                        sessionStorage.setItem("countryClaim", state_selected)
                        unlock_next()
                    break;

                    case localDomain == "eu.unionbindingcompany.com" && region_selected == "EU":
                        sessionStorage.setItem("countryClaim", state_selected)
                        unlock_next()
                    break;

                    case localDomain == "jp.unionbindingcompany.com" && region_selected == "JP":
                        sessionStorage.setItem("countryClaim", state_selected)
                        unlock_next()
                    break;

                    case (localDomain == "aus.unionbindingcompany.com" || localDomain == "nz.unionbindingcompany.com") && (region_selected == "AUS" || region_selected == "NZL"):
                        goExternal("https://warrantyflow.lovable.app/")
                    break;

                    default: redirect_country(region_selected) 
                    break;
                }

        } else {
            jQuery.ajax({
                url:"https://eu.unionbindingcompany.com/pages/global-distributors", 
                success:function(response) {

                    // La pagina /pages/global-distributors restituisce HTML:
                    // estraggo il blocco .distributor-info del paese selezionato (es. CHINA)
                    // e lo mostro cosi' com'e' (dati leggibili gia' formattati dalla pagina).
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(response, "text/html");
                    var target = (state_selected || country_selected || "").trim().toUpperCase();

                    var matched = null;
                    var infos = doc.querySelectorAll(".distributor-info");
                    for (var di = 0; di < infos.length; di++) {
                        var titleEl = infos[di].querySelector(".distributor-info__title h3");
                        if (titleEl && titleEl.textContent.trim().toUpperCase() === target) {
                            matched = infos[di];
                            break;
                        }
                    }

                    if (matched) {
                        claimResult_distributionContent.innerHTML = matched.outerHTML;
                        claimResult_distribution.classList.remove("hide");
                        claimStep1.classList.remove("active");
                        check_navigation("pre","after","show","hide",1,null);
                    }
                }
            })
        }
    }

    // START - FUNCTIONS

        function check_navigation(pre,after,pre_change,after_change,pre_step,after_step) {
            if (pre) {
                pre_change == "hidden" ? claimPre.classList.add("hidden") : claimPre.classList.remove("hidden")
                if (pre_step == "warranty-page") {
                    claimPre.querySelector(".cta").setAttribute("href", "/pages/new-warranty")
                } else {
                    claimPre.querySelector(".cta").removeAttribute("href")
                    claimPre.setAttribute("attr_gotostep", pre_step)
                }
            }
            if (after) {
                after_change == "hidden" ? claimAfter.classList.add("hidden") : claimAfter.classList.remove("hidden")
                after_change == "hide" ? claimAfter.classList.add("hide") : claimAfter.classList.remove("hide")
                claimAfter.setAttribute("attr_gotostep", after_step)
            }

            if (claimStep3.classList.contains("active")) {
                if (sessionStorage.getItem("involvedParts").length > 0) {
                    unlock_next()
                } else {
                    block_next()
                }
            }

        }

        function check_step() {
            var pageWrap = document.querySelector(".page-new-warranty-claim")
            if (pageWrap) pageWrap.classList.remove("warranty-info-active")
            var claimStepChoose = document.querySelector('.claim-step[attr_step="choose-product-type"]')
            if (claimStepChoose && claimStepChoose.classList.contains("active")) {
                // pagina di atterraggio diretta: nessun previous
                claimWarranty.classList.add("hide")
                claimPre.classList.add("hide")
                claimAfter.classList.add("hide")
            }
            var claimStepWarrantyInfo = document.querySelector('.claim-step[attr_step="warranty-info"]')
            if (claimStepWarrantyInfo && claimStepWarrantyInfo.classList.contains("active")) {
                // nav bar nascosta: i controlli (PREVIOUS + SUBMIT A WARRANTY CLAIM) sono inline nel box submit
                claimWarranty.classList.add("hide")
                claimPre.classList.add("hide")
                claimAfter.classList.add("hide")
                if (pageWrap) pageWrap.classList.add("warranty-info-active")
                syncRequestTexts()
                var warrantyInfoTitle = document.querySelector(".warranty-info-title")
                if (warrantyInfoTitle) {
                    warrantyInfoTitle.innerHTML = sessionStorage.getItem("bindingType") == "boots" ? WCI18N.warranty_title_boots : WCI18N.warranty_title_default
                }
            }
            if (claimStep1.classList.contains("active")) {
                claimWarranty.classList.add("hide")
                claimPre.classList.remove("hide")
                countries = " "
                countries = claimStep1_country.querySelectorAll(".country-step__single")
                step1()
                // PREVIOUS dello step 1: warranty-info se presente, altrimenti (step warranty-info disattivato) choose-product-type
                check_navigation("pre","after","show","", document.querySelector('.claim-step[attr_step="warranty-info"]') ? "warranty-info" : "choose-product-type","2")
                claimResult_distributionContent.innerHTML = ""
                claimResult_distribution.classList.add("hide")
                syncRequestTexts()
                // Ripristino affidabile dal DOM: se in cima al selettore c'è un paese
                // valido per procedere (stessa region del dominio), sblocca il NEXT.
                var selectedCountry = claimStep1_country.querySelector(".country-step__single")
                var stillPlaceholder = claimStep1_country.querySelector(".select-style__single--select")
                var selReg = selectedCountry ? selectedCountry.getAttribute("attr-region") : null
                var canProceed = !stillPlaceholder && (
                    (localDomain == "eu.unionbindingcompany.com" && selReg == "EU") ||
                    (localDomain == "unionbindingcompany.com" && selReg == "NA") ||
                    (localDomain == "jp.unionbindingcompany.com" && selReg == "JP")
                )
                if (canProceed) {
                    unlock_next()
                } else {
                    block_next()
                }
            }

            if (claimStep2.classList.contains("active")) {
                claimWarranty.classList.add("hide")
                claimPre.classList.remove("hide")
                step2()
                syncRequestTexts()
                var isCov = sessionStorage.getItem("isCovered")
                if (isCov === "yes" || isCov === "no") {
                    // scelta già fatta (visibile nel selettore): ripristina navigazione + sblocca
                    check_navigation("pre","after","show","show","1", isCov === "yes" ? "3" : "part-request")
                    unlock_next()
                } else {
                    check_navigation("pre","after","show","show","1","3")
                    block_next()
                }
            }
            // step involved parts
            if (claimStep3.classList.contains("active")) {
                var isPartReq3 = sessionStorage.getItem("requestType") == "Part Request"
                // Part Request: PREV torna al country (lo step 2 "is covered" e' saltato)
                check_navigation("pre","after","show","show", isPartReq3 ? "1" : "2", "4")
                // Part Request: il tipo si sceglie qui -> selettore visibile; Warranty: gia' scelto dai tile -> nascosto
                var typeSelect3 = document.querySelector(".involved-parts__binding-parts__select")
                if (typeSelect3) typeSelect3.classList.toggle("hide", !isPartReq3)
                claimWarranty.classList.add("hide")
                claimPre.classList.remove("hide")
                syncRequestTexts()
                var step3Desc = document.querySelector(".step3-desc")
                if (step3Desc) {
                    step3Desc.innerHTML = sessionStorage.getItem("bindingType") == "boots"
                        ? WCI18N.step3_desc_boots_l1 + "<br/>" + WCI18N.step3_desc_boots_l2
                        : WCI18N.step3_desc_default_l1 + "<br/>" + WCI18N.step3_desc_default_l2
                }
            }
            if (claimStep4.classList.contains("active")) {
                filterPurchaseYears()
                var step4Title = document.querySelector(".step4-title")
                if (step4Title) {
                    step4Title.innerHTML = sessionStorage.getItem("bindingType") == "boots" ? WCI18N.purchase_year_boots : WCI18N.purchase_year_default
                }
                var pYear = sessionStorage.getItem("purchasedYear")
                if (pYear && pYear !== "") {
                    // scelta già fatta (visibile nel selettore): ripristina navigazione + sblocca
                    var pInt = pYear === "don't know" ? 0 : parseInt(pYear)
                    check_navigation("pre","after","show","show","3", computePurchaseAfter(pInt))
                    unlock_next()
                } else {
                    check_navigation("pre","after","show","show","3","")
                    block_next()
                }
            }
            if (claimStepFormProcess1.classList.contains("active")) {
                check_navigation("pre","after","show","show","4","covered-2")
                block_next()
                var isBootsForm = sessionStorage.getItem("bindingType") == "boots"
                var formInfoTitle = document.querySelector(".form-info-title")
                if (formInfoTitle) {
                    formInfoTitle.innerHTML = isBootsForm ? WCI18N.form_info_boots : WCI18N.form_info_default
                }
                var photoEntireLabel = document.querySelector(".photo-entire-label")
                if (photoEntireLabel) {
                    photoEntireLabel.innerHTML = isBootsForm ? WCI18N.photo_entire_boots : WCI18N.photo_entire_default
                }
                // Anteprima file + controllo dimensione gestiti nello snippet
                // form-warranty-step1.liquid (addEventListener sugli input).
                // Proof of purchase: facoltativa per Warranty Claim -> nascondi
                var purchaseUpload = document.querySelector(".file-upload--purchase")
                if (purchaseUpload) {
                    if (sessionStorage.getItem("requestType") == "Part Request") {
                        purchaseUpload.classList.add("hide")
                    } else {
                        purchaseUpload.classList.remove("hide")
                    }
                }
            }
            if (claimStepFormProcess2.classList.contains("active")) {
                check_navigation("pre","after","show","show","covered-1","recap")
                claimSubmit.classList.add("hide")
                block_next()
                setupStateField()
            }
            if (claimStepFormRecap.classList.contains("active")) {
                check_navigation("pre","after","show","hide","covered-2","")
                claimSubmit.classList.remove("hide")
                var isBootsRecap = sessionStorage.getItem("bindingType") == "boots"
                var recapInfoTitle = document.querySelector(".recap-info-title")
                if (recapInfoTitle) {
                    recapInfoTitle.innerHTML = isBootsRecap ? WCI18N.recap_info_boots : WCI18N.recap_info_default
                }
                var recapEntireLabel = document.querySelector(".recap-entire-label")
                if (recapEntireLabel) {
                    recapEntireLabel.innerHTML = isBootsRecap ? WCI18N.recap_entire_boots : WCI18N.recap_entire_default
                }
                // Proof of Purchase (facoltativa): nel recap nascondi il blocco se non è stato caricato il file
                var purchaseInput = document.getElementById("purchase")
                var purchaseRecap = document.querySelector(".check-file__purchase")
                if (purchaseRecap) {
                    var purchaseBlock = purchaseRecap.closest(".check-file")
                    var hasPurchase = purchaseInput && purchaseInput.files && purchaseInput.files[0]
                    if (purchaseBlock) purchaseBlock.classList.toggle("hide", !hasPurchase)
                }
            }
            if (claimStepPartRequest.classList.contains("active")) {
                check_navigation("pre","after","show","hidden","1","")
                pageTitle.innerHTML = WCI18N.title_not_covered
            }
        }

        // function step_part_request() {
        //     claimStep2.classList.remove("active")
        //     claimStep4.classList.remove("active")
        //     claimStepPartRequest.classList.add("active")
        //     check_navigation("pre","after","show","hidden","2","")
        // }

        function step1() {
            if (countries) {
                countries.forEach(function(country){
                    if (!country.classList.contains("select-style__single--select")) {
                        country.addEventListener("click", async_country_step, false )
                    }
                })
            }
        }

        function step2() {
            claimStep1.classList.remove("active")
            claimStep2.classList.add("active")
            select_covered_arrow = select_covered.querySelector(".fa-chevron-down")
            covered.forEach(function(cover) {
                var attr_cover = cover.getAttribute("attr-covered")
                cover.addEventListener("click", function() {
                    // select_covered.classList.remove("open")
                    // select_covered_arrow.classList.remove("open")
                    select_covered.insertAdjacentElement('afterbegin', this);
                    if (select_covered.querySelector(".select-style__single--select")) {
                        select_covered.querySelector(".select-style__single--select").remove()
                    }

                    if (attr_cover == "yes") {
                        check_navigation("pre","after","show","show","1","3")
                        sessionStorage.setItem("requestType", "Warranty Claim")
                        syncRequestTexts()
                    } else {
                        check_navigation("pre","after","show","show","1","part-request")
                        sessionStorage.setItem("requestType", "Part Request")
                        syncRequestTexts()
                    }
                    sessionStorage.setItem("isCovered", attr_cover)
                    unlock_next()
                }, false )
            })
        }

        function step3() {
            claimStep2.classList.remove("active")
            claimStepPartRequest.classList.remove("active")
            claimStep3.classList.add("active")
            check_navigation("pre","after","show","show","2","4")
        }

        function step4() {
            block_next()
            claimStep3.classList.remove("active")
            claimStep4.classList.add("active")
            check_navigation("pre","after","show","show","","")
        }

        // Warranty Claim (requestType != "Part Request"): nasconde gli anni < 2024
        function filterPurchaseYears() {
            var minYear = 2024
            var isPartRequest = sessionStorage.getItem("requestType") == "Part Request"
            yearPurchaseOption.forEach(function(yearOpt){
                var y = parseInt(yearOpt.getAttribute("attr-purchased"))
                if (!isPartRequest && !isNaN(y) && y < minYear) {
                    yearOpt.classList.add("hide")
                } else {
                    yearOpt.classList.remove("hide")
                }
            })
        }

        // Step successivo in base all'anno di acquisto (stessa logica del click, riusabile per il ripristino)
        function computePurchaseAfter(purchased) {
            if (sessionStorage.getItem("requestType") == "Part Request") return "covered-1"
            if (purchased >= coveredYear) return "covered-1"
            var parts = sessionStorage.getItem("involvedParts") || ""
            if (parts.includes("Baseplate") || (parts.includes("Heelcup") && !parts.includes("Heelcup Hardware"))) {
                return "covered-1"
            }
            return "part-request"
        }

        function stepFormProcess1() {
            claimStep3.classList.remove("active")
            claimStep4.classList.remove("active")
            claimStepPartRequest.classList.remove("active")
            claimStepFormProcess1.classList.add("active")
            var preLink = "4" // to step 4 'purchase year'
            if (sessionStorage.getItem("requestType") == "Part Request") {
                preLink = "part-request"
            }
            check_navigation("pre","after","show","show",preLink,"covered-2")
            block_next()
        }

        // function createRequestPartList() {
            
        //     involvedPartsList = ""

        //     componentListPins.forEach(function(componentPinSingle){
        //         if (componentPinSingle.classList.contains("selected")) {
        //             var componentPinSingle_attrSpec = componentPinSingle.getAttribute("attr-spec")
        //             if (involvedPartsList.length > 0) {
        //                 involvedPartsList = involvedPartsList.concat(", ", componentPinSingle_attrSpec)
        //             } else {
        //                 involvedPartsList = involvedPartsList.concat(componentPinSingle_attrSpec)
        //             }
        //         }
        //     })
        //     sessionStorage.setItem("involvedParts", involvedPartsList)
        //     recapParts.innerHTML = involvedPartsList
        //     // console.log(sessionStorage.getItem("involvedParts"))
        // }

        function block_next() {
            claimAfter.classList.add("inactive")
        }

        function unlock_next() {
            claimAfter.classList.remove("inactive")
        }

        function cleanPartSelected() {
            sessionStorage.setItem("involvedParts", "")
            componentListPins.forEach(function(componentPin_clean){
                componentPin_clean.classList.remove("selected")
            })
            componentPartsImagePins.forEach(function(componentImagePin_clean){
                componentImagePin_clean.classList.remove("selected")
            })
            componentPartImages.forEach(function(partImage_clean){ 
                partImage_clean.classList.remove("selected")
            })
            block_next()
        }

        function checkSelectionParts() {
            checkPartInsert = false
            involvedPartsList = ""
            var componentPinSingle_attrSpec = ""
            componentListPins.forEach(function(componentPin_check){
                if (componentPin_check.classList.contains("selected")) {
                    checkPartInsert = true

                    componentPinSingle_attrSpec = componentPin_check.getAttribute("attr-spec")
                    if (involvedPartsList.length > 0) {
                        involvedPartsList = involvedPartsList.concat(", ", componentPinSingle_attrSpec)
                    } else {
                        involvedPartsList = involvedPartsList.concat(componentPinSingle_attrSpec)
                    }

                } 
                
                sessionStorage.setItem("involvedParts", involvedPartsList)
                recapParts.innerHTML = involvedPartsList

                if (checkPartInsert) {
                    unlock_next()
                } else {
                    block_next()
                }
            })
        }

        function checkDataCompileStep1() {
            var isBoots = selectedBindingType == "boots"
            // direction (Left/Right) obbligatoria per tutti; il colore è obbligatorio solo per i boots
            var colorOk = isBoots ? (recapColor.innerHTML.length != 0) : true
            if  (
                (recapModel.innerHTML.length != 0) &&
                (recapDirection.innerHTML.length != 0) &&
                (recapSize.innerHTML.length != 0) &&
                colorOk &&
                (stepFormContacts_imageB.files[0]) &&
                (stepFormContacts_imageP.files[0]) &&
                (stepFormMessage.value.trim().length != 0)
                ) {
                    unlock_next()
                } else {
                    block_next()
                }
        }

        function checkDataCompileStep2() {
            if (recapInfosFirstName.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='firstname']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='firstname']").classList.remove("compiled")
            }
            if (recapInfosLastName.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='lastname']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='lastname']").classList.remove("compiled")
            }
            if (recapInfosEmail.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='email']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='email']").classList.remove("compiled")
            }
            if (recapInfosPhone.innerHTML.length != 0) {
                document.querySelector(".step-form-contact .input-contact input[name='phone']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-contact .input-contact input[name='phone']").classList.remove("compiled")
            }
            if (recapShipAddr1.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='address1']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='address1']").classList.remove("compiled")
            }
            if (recapShipCity.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='city']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='city']").classList.remove("compiled")
            }
            if (recapShipState.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='stateclaim']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='stateclaim']").classList.remove("compiled")
            }
            if (recapShipZip.innerHTML.length != 0) {
                document.querySelector(".step-form-ship .input-contact input[name='zip']").classList.add("compiled")
            } else {
                document.querySelector(".step-form-ship .input-contact input[name='zip']").classList.remove("compiled")
            }
            if  (
                (recapInfosFirstName.innerHTML.length != 0) &&
                (recapInfosLastName.innerHTML.length != 0) &&
                (recapInfosEmail.innerHTML.length != 0) &&
                (recapInfosPhone.innerHTML.length != 0) &&
                (recapShipAddr1.innerHTML.length != 0) &&
                (recapShipCity.innerHTML.length != 0) &&
                (recapShipState.innerHTML.length != 0) &&
                (recapShipZip.innerHTML.length != 0) 
                ) {
                    unlock_next()
                } else {
                    block_next()
                }
        }

        function scrollTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        function goToStepPartRequest() {
            // Flusso "Part Request" (?step=part-request): boots esclusi. Si salta la scelta del
            // tipo (choose-product-type) e si va direttamente al country; il tipo di attacco si
            // sceglie nello step 3 con i bottoni di .involved-parts__binding-parts__select
            // (resi visibili in check_step). Default tipo = regular (mai boots).
            sessionStorage.setItem("requestType", "Part Request")
            sessionStorage.setItem("bindingType", "regular")
            syncRequestTexts()
            claimSteps.forEach(function(s){ s.classList.remove("active") })
            claimStep1.classList.add("active")
            check_step()
            check_navigation("pre","after","hidden","show","1","3")
        }

    // END - FUNCTIONS


    // START - FIRST CONTROLS

    check_step()
    
    if (stepUrl === 'part-request') {
        goToStepPartRequest()
    }

    // END - FIRST CONTROLS


    // START - CHOOSE PRODUCT TYPE
    var chooseTiles = document.querySelectorAll(".choose-product-type__tile")
    chooseTiles.forEach(function(tile){
        tile.addEventListener("click", function(){
            var type = this.getAttribute("attr-binding-type")
            sessionStorage.setItem("bindingType", type)
            chooseTiles.forEach(function(t){ t.classList.remove("selected") })
            this.classList.add("selected")
            // pre-seleziona il tipo allo step 3 (trigger del bottone esistente)
            var btn = document.querySelector('.involved-parts__binding-parts__select__btn[attr-binding-type="' + type + '"]')
            if (btn) btn.click()
            // testo descrizione (warranty-info + step 2): boots vs default
            setWarrantyDescription(type)
            // avanza allo step warranty-info; se lo step warranty-info disattivato nel template
            // (flag wc_show_warranty_info = false) non e' nel DOM, si passa direttamente allo step 1 (country)
            claimSteps.forEach(function(s){ s.classList.remove("active") })
            var stepWarrantyInfo = document.querySelector('.claim-step[attr_step="warranty-info"]')
            if (stepWarrantyInfo) {
                stepWarrantyInfo.classList.add("active")
            } else {
                claimStep1.classList.add("active")
            }
            check_step()
            scrollTop()
        })
    })

    function setWarrantyDescription(type) {
        var isBoots = (type == "boots")
        document.querySelectorAll(".warranty-desc--default").forEach(function(el){
            el.classList.toggle("hide", isBoots)
        })
        document.querySelectorAll(".warranty-desc--boots").forEach(function(el){
            el.classList.toggle("hide", !isBoots)
        })
        // Boots: nascondi l'intera sezione "Union Replacement Parts"
        document.querySelectorAll(".warranty-info__actions").forEach(function(el){
            el.classList.toggle("hide", isBoots)
        })
    }

    // Accordion "Union Gear Tips" nello step warranty-info
    var tipsAccordion = document.querySelector(".warranty-info__tips")
    if (tipsAccordion) {
        var tipsTitle = tipsAccordion.querySelector(".text-accordion__title")
        tipsTitle.addEventListener("click", function(){
            var isClosed = tipsAccordion.classList.contains("closed")
            tipsAccordion.classList.toggle("closed", !isClosed)
            tipsTitle.querySelector("img").classList.toggle("closed", !isClosed)
            tipsAccordion.querySelector(".text-accordion__content").classList.toggle("hidden", !isClosed)
        })
    }

    // CTA "SUBMIT A WARRANTY CLAIM": procede allo step 1 (country)
    document.querySelectorAll(".warranty-info__proceed").forEach(function(btn){
        btn.addEventListener("click", function(){
            claimSteps.forEach(function(s){ s.classList.remove("active") })
            claimStep1.classList.add("active")
            check_step()
            scrollTop()
        })
    })

    // CTA "PREVIOUS" inline: torna alla scelta prodotto (choose-product-type)
    document.querySelectorAll(".warranty-info__back").forEach(function(btn){
        btn.addEventListener("click", function(){
            claimSteps.forEach(function(s){ s.classList.remove("active") })
            var stepChoose = document.querySelector('.claim-step[attr_step="choose-product-type"]')
            if (stepChoose) stepChoose.classList.add("active")
            check_step()
            scrollTop()
        })
    })

    // CTA "SUBMIT A PART REQUEST": via di fuga verso lo step part-request
    document.querySelectorAll(".warranty-info__goto-part-request").forEach(function(btn){
        btn.addEventListener("click", function(){
            claimSteps.forEach(function(s){ s.classList.remove("active") })
            claimStepPartRequest.classList.add("active")
            check_step()
            scrollTop()
        })
    })
    // END - CHOOSE PRODUCT TYPE


    // START - PART REQUEST

    goto_step3.addEventListener("click", function() {
        sessionStorage.setItem("requestType", "Part Request")
        syncRequestTexts()
        if (sessionStorage.getItem("involvedParts").length > 0) {
            stepFormProcess1()
        } else {
            step3()
        }
    }, false )

    // END - PART REQUEST


    // INVOLVED PARTS - START

    // BTN COMPONENTS TYPE
    componentsPartsBtns.forEach(function(componentBtn){
        componentBtn.addEventListener("click", function() {

            componentsPartsBtns.forEach(function(componentBtn_reset){
                componentBtn_reset.classList.add("unselected")
            })
            this.classList.remove("unselected")

            cleanPartSelected()

            var componentBtnType = this.getAttribute("attr-binding-type")
            selectedBindingType = componentBtnType
            sessionStorage.setItem("bindingType", componentBtnType)

            componentsPartsImages.forEach(function(componentsPartsImage){
                var compType = componentsPartsImage.getAttribute("attr-binding-type")
                componentBtnType == compType ? componentsPartsImage.classList.remove("hide") : componentsPartsImage.classList.add("hide")
            })
            componentsPartsLists.forEach(function(componentsPartsList){
                var compType = componentsPartsList.getAttribute("attr-binding-type")
                componentBtnType == compType ? componentsPartsList.classList.remove("hide") : componentsPartsList.classList.add("hide")
            })

            // filter models inside "select model" (nessuna preselezione: resta sempre "Select Here")
            stepFormModels.forEach(function(stepFormModel){
                var bindType = stepFormModel.getAttribute("attr-type")
                if (!stepFormModel.classList.contains('select-style__single--select')) {
                    componentBtnType == bindType ? stepFormModel.classList.remove("hide") : stepFormModel.classList.add("hide")
                } else {
                    stepFormModel.classList.remove("hide")
                }
            })

            // BOOTS: mostra Boot size + Color (la direction Left/Right resta anche per i boots); altrimenti flusso standard
            var isBoots = componentBtnType == "boots"
            if (fieldSize) fieldSize.classList.toggle("hide", isBoots)
            if (fieldBootSize) fieldBootSize.classList.toggle("hide", !isBoots)
            if (fieldColor) fieldColor.classList.toggle("hide", !isBoots)
            // reset delle selezioni che dipendono dal tipo
            recapSize.innerHTML = ""
            recapColor.innerHTML = ""
            recapDirection.innerHTML = ""
            checkDataCompileStep1()

        }, false )
    })

    // PIN LIST
    componentListPins.forEach(function(componentPin){
        componentPin.addEventListener("click", function() {

            var pinPart = this.getAttribute("attr-spec")
            var pinPart_type = this.getAttribute("attr-binding-type")

            if (this.classList.contains("selected")) {
                this.classList.remove("selected")
            } else {
                this.classList.add("selected")
            } 

            // createRequestPartList()

            componentPartsImagePins.forEach(function(componentImagePin){
                
                var pinImagePart = componentImagePin.getAttribute("attr-spec")
                var pinImagePart_type = componentImagePin.getAttribute("attr-binding-type")

                if ((pinImagePart === pinPart) && (pinImagePart_type === pinPart_type)) {
                    if (componentImagePin.classList.contains("selected")) {
                        componentImagePin.classList.remove("selected")
                    } else {
                        componentImagePin.classList.add("selected")
                    } 
                }
            })

            componentPartImages.forEach(function(partImage){
                
                var partImageName = partImage.getAttribute("attr-spec")
                var partImageType = partImage.getAttribute("attr-binding-type")

                if ((partImageName === pinPart) && (partImageType === pinPart_type)) {
                    if (partImage.classList.contains("selected")) {
                        partImage.classList.remove("selected")
                    } else {
                        partImage.classList.add("selected")
                    } 
                }
            })

            checkSelectionParts()

        }, false )
    })

    // PIN IMAGES
    componentPartsImagePins.forEach(function(componentImagePin){
        componentImagePin.addEventListener("click", function() {

            var pinPart = this.getAttribute("attr-spec")
            var pinPart_type = this.getAttribute("attr-binding-type")

            if (this.classList.contains("selected")) {
                this.classList.remove("selected")
            } else {
                this.classList.add("selected")
            } 

            // createRequestPartList()

            componentListPins.forEach(function(componentPin){
                
                var pinImagePart = componentPin.getAttribute("attr-spec")
                var pinImagePart_type = componentPin.getAttribute("attr-binding-type")

                if ((pinImagePart === pinPart) && (pinImagePart_type === pinPart_type)) {
                    if (componentPin.classList.contains("selected")) {
                        componentPin.classList.remove("selected")
                    } else {
                        componentPin.classList.add("selected")
                    } 
                }
            })

            componentPartImages.forEach(function(partImage){
                
                var partImageName = partImage.getAttribute("attr-spec")
                var partImageType = partImage.getAttribute("attr-binding-type")

                if ((partImageName === pinPart) && (partImageType === pinPart_type)) {
                    if (partImage.classList.contains("selected")) {
                        partImage.classList.remove("selected")
                    } else {
                        partImage.classList.add("selected")
                    } 
                }
            })

            checkSelectionParts()

        }, false )
    })

    // INVOLVED PARTS - END


    // PURCHASED YEAR - START
    
    yearPurchaseOption.forEach(function(yearPurchase){
        yearPurchase.addEventListener("click", function() {
            unlock_next()
            if(!this.classList.contains("select-style__single--select")) {
                yearPurchaseSelect.insertAdjacentElement('afterbegin', this);
                if (yearPurchaseSelect.querySelector(".select-style__single--select")) {
                    yearPurchaseSelect.querySelector(".select-style__single--select").classList.add("hide")
                }
                yearPurchaseSelect.insertAdjacentElement('afterbegin', this);
                // yearPurchaseSelect.classList.remove("open")
                // yearPurchaseSelect.querySelector(".fa-chevron-down").classList.remove("open")
                
            }

            var purchased = parseInt(yearPurchase.getAttribute("attr-purchased"))

            check_navigation("pre","after","show","show","3", computePurchaseAfter(purchased))

            if (purchased != 0) {
                sessionStorage.setItem("purchasedYear", purchased)
                recapYear.innerHTML = purchased
            } else {
                sessionStorage.setItem("purchasedYear", "don't know")
                recapYear.innerHTML = WCI18N.dont_know
            }
        })
    })
    // PURCHASED YEAR - END


    // FORM STEPS - START

    stepFormModels.forEach(function(stepFormModel){
        stepFormModel.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormModels.insertAdjacentElement('afterbegin', this);
                // stepSelectFormModels.classList.remove("open")
                // stepSelectFormModels.querySelector(".fa-chevron-down").classList.remove("open")
                if (stepSelectFormModels.querySelector(".select-style__single--select")) {
                    stepSelectFormModels.querySelector(".select-style__single--select").remove()
                }
                var attr_model = stepFormModel.getAttribute("attr-model")
                // console.log(attr_model)
                recapModel.innerHTML = attr_model
            }
            checkDataCompileStep1()
        })
    })
    stepFormDirections.forEach(function(stepFormDirection){
        stepFormDirection.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormDirections.insertAdjacentElement('afterbegin', this);
                // stepSelectFormDirections.classList.remove("open")
                // stepSelectFormDirections.querySelector(".fa-chevron-down").classList.remove("open")
                if (stepSelectFormDirections.querySelector(".select-style__single--select")) {
                    stepSelectFormDirections.querySelector(".select-style__single--select").remove()
                }
                var attr_direction = stepFormDirection.getAttribute("attr-direction")
                // console.log(attr_direction)
                recapDirection.innerHTML = attr_direction
            }
            checkDataCompileStep1()
        })
    })
    stepFormSizes.forEach(function(stepFormSize){
        stepFormSize.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormSizes.insertAdjacentElement('afterbegin', this);
                // stepSelectFormSizes.classList.remove("open")
                // stepSelectFormSizes.querySelector(".fa-chevron-down").classList.remove("open")
                if (stepSelectFormSizes.querySelector(".select-style__single--select")) {
                    stepSelectFormSizes.querySelector(".select-style__single--select").remove()
                }
                var attr_size = stepFormSize.getAttribute("attr-size")
                // console.log(attr_size)
                recapSize.innerHTML = attr_size
            }
            checkDataCompileStep1()
        })
    })
    // BOOTS: dropdown Boot size (Mondo) -> alimenta lo stesso recapSize
    stepFormBootSizes.forEach(function(stepFormBootSize){
        stepFormBootSize.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormBootSizes.insertAdjacentElement('afterbegin', this);
                if (stepSelectFormBootSizes.querySelector(".select-style__single--select")) {
                    stepSelectFormBootSizes.querySelector(".select-style__single--select").remove()
                }
                recapSize.innerHTML = this.getAttribute("attr-size")
            }
            checkDataCompileStep1()
        })
    })
    // BOOTS: dropdown Color -> recapColor (obbligatorio solo per i boots)
    stepFormColors.forEach(function(stepFormColor){
        stepFormColor.addEventListener("click", function() {
            if(!this.classList.contains("select-style__single--select")) {
                stepSelectFormColors.insertAdjacentElement('afterbegin', this);
                if (stepSelectFormColors.querySelector(".select-style__single--select")) {
                    stepSelectFormColors.querySelector(".select-style__single--select").remove()
                }
                recapColor.innerHTML = this.getAttribute("attr-color")
            }
            checkDataCompileStep1()
        })
    })
    stepFormMessage.onkeyup = function(){
        recapMessage.innerHTML = stepFormMessage.value;
        checkDataCompileStep1()
    }

    stepFormContacts_imageB.addEventListener('change', function () {
        checkDataCompileStep1()
    }, false);
    stepFormContacts_imageP.addEventListener('change', function () {
        checkDataCompileStep1()
    }, false);

    // stepFormCountries.forEach(function(stepFormCountry){
    //     stepFormCountry.addEventListener("click", function() {
    //         if(!this.classList.contains("select-style__single--select")) {
    //             stepSelectFormCountries.insertAdjacentElement('afterbegin', this);
    //             stepSelectFormCountries.classList.remove("open")
    //             if (stepSelectFormCountries.querySelector(".select-style__single--select")) {
    //                 stepSelectFormCountries.querySelector(".select-style__single--select").remove()
    //             }
    //             var attr_filter = stepFormCountry.getAttribute("attr-filter")
    //             // console.log(attr_filter)
    //             recapShipCountry.innerHTML = attr_filter
    //         }
    //         checkDataCompileStep2()
    //     })
    // })
    stepFormContacts_firstname.onkeyup = function(){
        recapInfosFirstName.innerHTML = stepFormContacts_firstname.value;
        checkDataCompileStep2()
    }
    stepFormContacts_lastname.onkeyup = function(){
        recapInfosLastName.innerHTML = stepFormContacts_lastname.value;
        checkDataCompileStep2()
    }
    stepFormContacts_email.onkeyup = function(){
        recapInfosEmail.innerHTML = stepFormContacts_email.value;
        checkDataCompileStep2()
    }
    stepFormContacts_phone.onkeyup = function(){
        recapInfosPhone.innerHTML = stepFormContacts_phone.value;
        checkDataCompileStep2()
    }
    stepFormShips_address1.onkeyup = function(){
        recapShipAddr1.innerHTML = stepFormShips_address1.value;
        checkDataCompileStep2()
    }
    stepFormShips_address2.onkeyup = function(){
        recapShipAddr2.innerHTML = stepFormShips_address2.value;
    }
    stepFormShips_city.onkeyup = function(){
        recapShipCity.innerHTML = stepFormShips_city.value;
        checkDataCompileStep2()
    }
    stepFormShips_state.onkeyup = function(){
        recapShipState.innerHTML = stepFormShips_state.value;
        checkDataCompileStep2()
    }
    // Select stato per UNITED STATES / CANADA (alimentano lo stesso recap del text input)
    if (stepFormShips_stateUS) {
        stepFormShips_stateUS.onchange = function(){
            recapShipState.innerHTML = this.value;
            checkDataCompileStep2()
        }
    }
    if (stepFormShips_stateCA) {
        stepFormShips_stateCA.onchange = function(){
            recapShipState.innerHTML = this.value;
            checkDataCompileStep2()
        }
    }
    // In base al paese scelto nello step 1 (countryClaim) mostra text input o il select giusto
    function setupStateField() {
        var country = sessionStorage.getItem("countryClaim")
        stepFormShips_state.classList.remove("hide")
        if (stepFormShips_stateUS) stepFormShips_stateUS.classList.add("hide")
        if (stepFormShips_stateCA) stepFormShips_stateCA.classList.add("hide")
        if (country == "UNITED STATES" && stepFormShips_stateUS) {
            stepFormShips_state.classList.add("hide")
            stepFormShips_stateUS.classList.remove("hide")
            recapShipState.innerHTML = stepFormShips_stateUS.value
        } else if (country == "CANADA" && stepFormShips_stateCA) {
            stepFormShips_state.classList.add("hide")
            stepFormShips_stateCA.classList.remove("hide")
            recapShipState.innerHTML = stepFormShips_stateCA.value
        } else {
            recapShipState.innerHTML = stepFormShips_state.value
        }
    }
    stepFormShips_zip.onkeyup = function(){
        recapShipZip.innerHTML = stepFormShips_zip.value;
        checkDataCompileStep2()
    }
    stepFormShips_country.onkeyup = function(){
        recapShipCountry.innerHTML = stepFormShips_country.value;
        checkDataCompileStep2()
    }
    // Compilazione automatica del browser: non genera keyup, quindi riusa gli stessi handler su input/change
    ;[stepFormContacts_firstname, stepFormContacts_lastname, stepFormContacts_email, stepFormContacts_phone,
      stepFormShips_address1, stepFormShips_address2, stepFormShips_city, stepFormShips_zip].forEach(function(field){
        if (!field) return
        var sync = function(){ if (field.onkeyup) field.onkeyup() }
        field.addEventListener("input", sync)
        field.addEventListener("change", sync)
    })
    claimSubmitPrivacy.addEventListener("change", function(){
        if (this.checked) {
            claimSubmitBtn.classList.remove("disabled")
        } else {
            claimSubmitBtn.classList.add("disabled")
        }
    })

    claimSubmitBtn.addEventListener("click", function(){

        if (!claimSubmitBtn.classList.contains("disabled")) {
            claimSubmitBtn.classList.add("hide")
            claimSubmit.querySelector(".loader").classList.remove("hide")
        }

        // Canale di invio: app custom Core (store dove il template stampa .core-warranty-form),
        // altrimenti Globo Form Builder (flusso storico, invariato qui sotto).
        var coreFormPanel = document.querySelector('.core-warranty-form')
        if (coreFormPanel) {
            submitClaimToCore(coreFormPanel)
            return
        }
        
        /*
            globo form panel id
            NA: 96720
            EU: 93118
            AUS: 81463
            NZ: ???
        */

        let waranty_form_panel = document.querySelector('.globo-formbuilder')
        let waranty_form_panel__id = waranty_form_panel.getAttribute("data-id")

        var form_warranty = document.querySelector('.g-container')

        var info__firstname = document.getElementById(waranty_form_panel__id+'-text')
        var info__lastname = document.getElementById(waranty_form_panel__id+'-text-2')
        var info__email = document.getElementById(waranty_form_panel__id+'-text-3')
        var info__phone = document.getElementById(waranty_form_panel__id+'-text-4')
        var ship__addr1 = document.getElementById(waranty_form_panel__id+'-text-5')
        var ship__addr2 = document.getElementById(waranty_form_panel__id+'-text-6')
        var ship__city = document.getElementById(waranty_form_panel__id+'-text-7')
        var ship__state = document.getElementById(waranty_form_panel__id+'-text-8')
        var ship__zip = document.getElementById(waranty_form_panel__id+'-text-9')
        var ship__country = document.getElementById(waranty_form_panel__id+'-text-10')
        var info__message = document.getElementById(waranty_form_panel__id+'-text-11')
        var info__model = document.getElementById(waranty_form_panel__id+'-text-12')
        var info__direction = document.getElementById(waranty_form_panel__id+'-text-13')
        var info__size = document.getElementById(waranty_form_panel__id+'-text-14')
        var info__year = document.getElementById(waranty_form_panel__id+'-text-15')
        var info__type = document.getElementById(waranty_form_panel__id+'-text-16')
        var info__parts = document.getElementById(waranty_form_panel__id+'-text-17')
        var info__color = document.getElementById(waranty_form_panel__id+'-text-1')
        var image__b = document.getElementById(waranty_form_panel__id+'-file')
        var image__p = document.getElementById(waranty_form_panel__id+'-file-1')
        var image__purchase = document.getElementById(waranty_form_panel__id+'-file-2')

        info__firstname.value = recapInfosFirstName.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__lastname.value = recapInfosLastName.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__email.value = recapInfosEmail.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__phone.value = recapInfosPhone.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__addr1.value = recapShipAddr1.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__addr2.value = recapShipAddr2.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__city.value = recapShipCity.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__state.value = recapShipState.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__zip.value = recapShipZip.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        ship__country.value = recapShipCountry.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__message.value = recapMessage.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__model.value = recapModel.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__direction.value = recapDirection.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__size.value = recapSize.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        if (info__color) info__color.value = recapColor.innerHTML.replace('<font style="vertical-align: inherit;"><font style="vertical-align: inherit;">', '').replace('</font></font>', '')
        info__year.value = sessionStorage.getItem("purchasedYear") // valore canonico (numero o "don't know"), indipendente dal display tradotto
        info__type.value = sessionStorage.getItem("requestType")
        info__parts.value = sessionStorage.getItem("involvedParts")
        image__b.files = infoImage__b.files
        image__p.files = infoImage__p.files
        infoImage__purchase.files ? image__purchase.files = infoImage__purchase.files : null

        form_warranty.querySelector(".submit").click(); 


    })
    

    // INVIO VIA APP CORE - START
    // POST multipart all'app proxy /apps/core/form-submit (form "warranty_claim" definito nell'app).
    // Le chiavi dei campi devono combaciare con le key della definizione del form (snake_case).
    var coreSubmitting = false
    function submitClaimToCore(panel) {
        if (claimSubmitBtn.classList.contains("disabled") || coreSubmitting) return
        coreSubmitting = true

        var loader = claimSubmit.querySelector(".loader")
        var errorBox = claimSubmit.querySelector(".error-submit")
        if (errorBox) { errorBox.textContent = ""; errorBox.classList.add("hidden") }

        var txt = function(el){ return el ? (el.textContent || "").trim() : "" }
        var ss = function(k){ return sessionStorage.getItem(k) || "" }

        var fd = new FormData()
        fd.append("form_handle", panel.getAttribute("data-form-handle") || "warranty_claim")
        fd.append("page_url", window.location.href)
        var firstName = txt(recapInfosFirstName), lastName = txt(recapInfosLastName)
        var values = {
            request_type: ss("requestType"),
            product_type: ss("bindingType"),
            country_claim: ss("countryClaim"),
            name: (firstName + " " + lastName).trim(),
            first_name: firstName,
            last_name: lastName,
            email: txt(recapInfosEmail),
            phone: txt(recapInfosPhone),
            address_1: txt(recapShipAddr1),
            address_2: txt(recapShipAddr2),
            city: txt(recapShipCity),
            state: txt(recapShipState),
            zip: txt(recapShipZip),
            country: txt(recapShipCountry),
            model: txt(recapModel),
            direction: txt(recapDirection),
            size: txt(recapSize),
            color: txt(recapColor),
            purchase_year: ss("purchasedYear"), // valore canonico (numero o "don't know")
            involved_parts: ss("involvedParts"),
            message: txt(recapMessage),
            language: document.documentElement.lang || ""
        }
        Object.keys(values).forEach(function(k){ fd.append(k, values[k]) })
        var files = { photo_binding: infoImage__b, photo_part: infoImage__p, proof_of_purchase: infoImage__purchase }
        Object.keys(files).forEach(function(k){
            var input = files[k]
            if (input && input.files && input.files[0]) fd.append(k, input.files[0])
        })

        var fail = function(message){
            coreSubmitting = false
            if (loader) loader.classList.add("hide")
            claimSubmitBtn.classList.remove("hide")
            if (errorBox) { errorBox.textContent = message; errorBox.classList.remove("hidden") }
        }

        fetch("/apps/core/form-submit", { method: "POST", headers: { "Accept": "application/json" }, body: fd })
            .then(function(r){ return r.json().catch(function(){ return { ok: false } }) })
            .then(function(res){
                if (res && res.ok) {
                    window.location.href = panel.getAttribute("data-thankyou-url") || "/pages/warranty-thank-you"
                } else {
                    var detail = (res && res.error) ? String(res.error) : ""
                    fail(/file|MB/i.test(detail) ? WCI18N.submit_error_files : WCI18N.submit_error)
                    if (detail && window.console) console.warn("[warranty-claim] submit rejected:", detail)
                }
            })
            .catch(function(){ fail(WCI18N.submit_error) })
    }
    // INVIO VIA APP CORE - END

    // FORM STEPS - END


    // NAVIGATION BUTTONS - START
    claimPre.addEventListener("click", function(){
        var goToStep = this.getAttribute("attr_gotostep")
        claimSteps.forEach(function(claimStep){
            if (claimStep.getAttribute("attr_step") == goToStep) {
                claimStep.classList.add("active")
            } else {
                claimStep.classList.remove("active")
            }
        })
        check_step()
        scrollTop()
    })
    claimAfter.addEventListener("click", function(){
        if (!this.classList.contains("inactive")) {
            var goToStep = this.getAttribute("attr_gotostep")
            claimSteps.forEach(function(claimStep){
                if (claimStep.getAttribute("attr_step") == goToStep) {
                    claimStep.classList.add("active")
                } else {
                    claimStep.classList.remove("active")
                }        
            })
            check_step()
            scrollTop()
        } else {
            errorAfter.classList.remove("hidden")
            setTimeout(function(){
                errorAfter.classList.add("hidden")
            }, 2000)
        }
    })
    // NAVIGATION BUTTONS - END


    function redirect_country(region_selected) {
        // Mantiene tipo (boots...) e paese scelti: lo store di destinazione salta
        // choose-product-type + warranty-info + country e atterra allo step dopo la country.
        var carry = "?type=" + encodeURIComponent(sessionStorage.getItem("bindingType") || "")
                  + "&country=" + encodeURIComponent(state_selected || "")
        if (region_selected == "EU") {
            window.location.replace("https://eu.unionbindingcompany.com/pages/warranty-claim" + carry)
        } else if (region_selected == "NA") {
            window.location.replace("https://unionbindingcompany.com/pages/warranty-claim" + carry)
        } else if (region_selected == "JP") {
            window.location.replace("https://jp.unionbindingcompany.com/pages/warranty" + carry)
        } else if (region_selected == "AUS") {
            window.location.replace("https://aus.unionbindingcompany.com/pages/warranty-claim" + carry)
        } else if (region_selected == "NZL") {
            window.location.replace("https://nz.unionbindingcompany.com/pages/warranty-claim" + carry)
        }
    }

    // Deep link: /pages/warranty-claim?type=boots[&country=...]
    // - type: parte col tipo selezionato saltando "choose-product-type" (atterra su warranty-info)
    // - country (redirect da un altro store): preseleziona anche il paese e salta direttamente
    //   allo step successivo alla country (step 2), mantenendo tipo + paese.
    var typeUrl = urlParams.get('type')
    if (typeUrl) {
        var typeTile = document.querySelector('.choose-product-type__tile[attr-binding-type="' + typeUrl + '"]')
        if (typeTile) typeTile.click()
    }
    var countryUrl = urlParams.get('country')
    if (countryUrl) {
        var countryOption = document.querySelector('.country-step__single[attr-filter="' + countryUrl + '"]')
        if (countryOption) {
            // riusa la logica di selezione paese: qui la region coincide col dominio -> setta
            // countryClaim e sblocca (nessun nuovo redirect).
            async_country_step.call(countryOption)
            // salta allo step successivo alla country
            claimSteps.forEach(function(s){ s.classList.remove("active") })
            var stepAfterCountry = document.querySelector('.claim-step[attr_step="2"]')
            if (stepAfterCountry) stepAfterCountry.classList.add("active")
            check_step()
            scrollTop()
        }
    }

})(document);
  